import type {PullRequestPickerPullRequest$data} from '@github-ui/item-picker/pr'
import {commitMutation, type Environment, graphql} from 'react-relay'
import type {linkPullRequestsMutation} from './__generated__/linkPullRequestsMutation.graphql'

type LinkPullRequestsMutationParams = {
  environment: Environment
  input: {baseIssueOrPullRequestId: string; linkingIds: string[]}
  onError: (error: Error) => void
  linkingPrs: PullRequestPickerPullRequest$data[]
}

export function linkPullRequestsMutation({
  environment,
  input: {baseIssueOrPullRequestId, linkingIds},
  onError,
  linkingPrs,
}: LinkPullRequestsMutationParams) {
  const optimisticResponse = {
    linkIssueOrPullRequest: {
      baseIssueOrPullRequest: {
        __typename: 'Issue',
        id: baseIssueOrPullRequestId,
        __isNode: 'Issue',
        closedByPullRequestsReferences: {
          edges: (linkingPrs || []).map(pr => {
            const {url, number, title, isDraft, state, repository, id} = pr
            const {id: repoId, name, nameWithOwner, owner} = repository
            const {login, __typename} = owner

            return {
              node: {
                id,
                isDraft,
                number,
                url,
                title,
                state,
                repository: {
                  id: repoId,
                  name,
                  nameWithOwner,
                  owner: {
                    id,
                    login,
                    __typename,
                  },
                },
              },
            }
          }),
        },
      },
    },
  }

  return commitMutation<linkPullRequestsMutation>(environment, {
    mutation: graphql`
      mutation linkPullRequestsMutation($baseIssueOrPullRequestId: ID!, $linkingIds: [ID!]!) @raw_response_type {
        linkIssueOrPullRequest(input: {baseIssueOrPullRequestId: $baseIssueOrPullRequestId, linkingIds: $linkingIds}) {
          baseIssueOrPullRequest {
            ... on Issue {
              closedByPullRequestsReferences(first: 10, includeClosedPrs: true) {
                edges {
                  node {
                    ...PullRequestPickerPullRequest
                  }
                }
              }
            }
          }
        }
      }
    `,
    variables: {baseIssueOrPullRequestId, linkingIds},
    optimisticResponse,
    onError,
  })
}
